import { ComponentView, View } from "binder"
import { MultiLineTextInputViewModel } from "./multiLineTextInput-viewModel"

export class MultiLineTextInputView extends ComponentView<MultiLineTextInputViewModel>{
    GetViewUniqueId(): string {
        return "V-1F7F8045-5092-41F8-972A-A633C72BE80F"
    }
    loadHtml(): string {
        let element = require('./multiLineTextInput.html').default;
        let style = require('./multiLineTextInput.less');
        return element;
    }
    constructor() {
       super();
       this.isEventsSet = false;
       this.isShowingCopiedMessage = false;
    }

    
    public set text(v: string) { 
        this._text = v;
        this.inputElement.value = this._text;
    } public get text(): string {
        let a = this._text;
        if(a!=null && a!='' && this.slots!=null && this.slots!=''){
            a=a.toString();
            let index = [...this.slots].map(x=>a.indexOf(x)).filter(x=>x>=0).reduce((p,c)=>p<c?p:c,100000);
            a=a.substring(0,index);
        }
        return a;
    } private _text: string;
    public set showingText(v: string) { this._showingText = v; } public get showingText(): string { return this._showingText;} private _showingText: string;
    public set isreadonly(v: boolean) { this._isreadonly = v; } public get isreadonly(): boolean { return this._isreadonly;} private _isreadonly: boolean;
    public set disabled(v: boolean) { this._disabled = v; } public get disabled(): boolean { return this._disabled;} private _disabled: boolean;
    public set isnumeric(v: boolean) { this._isnumeric = v; } public get isnumeric(): boolean { return this._isnumeric;} private _isnumeric: boolean;
    public set maxlength(v: number) { this._maxlength = v; } public get maxlength(): number { return this._maxlength;} private _maxlength: number;
    public set min(v: number) { this._min = v; } public get min(): number { return this._min;} private _min: number;
    public set max(v: number) { this._max = v; } public get max(): number { return this._max;} private _max: number;
    public set inputElement(v: HTMLTextAreaElement) { 
        this._inputElement = v; 
        this.SetupRegex();
    } public get inputElement(): HTMLTextAreaElement { return this._inputElement;} private _inputElement: HTMLTextAreaElement;
    public set placeholder(v: string) { 
        this._placeholder = v; 
        this.SetupRegex();
    } public get placeholder(): string { return this._placeholder;} private _placeholder: string;
    public set slots(v: string) { 
        this._slots = v; 
        this.SetupRegex();
    } public get slots(): string { return this._slots;} private _slots: string;
    public set accepts(v: string) { 
        this._accepts = v; 
    } public get accepts(): string { return this._accepts;} private _accepts: string;
    public set cancopy(v: boolean) { this._cancopy = v; } public get cancopy(): boolean { return this._cancopy;} private _cancopy: boolean;
    public set isShowingCopiedMessage(v: boolean) { this._isShowingCopiedMessage = v; } public get isShowingCopiedMessage(): boolean { return this._isShowingCopiedMessage;} private _isShowingCopiedMessage: boolean;
    public set rowsheight(v: number) { this._rowsheight = v; } public get rowsheight(): number { return this._rowsheight;} private _rowsheight: number;
    public set caretposition(v: number) { this._caretposition = v; } public get caretposition(): number { return this._caretposition;} private _caretposition: number;

    keyup(x){
        this.firstlevelElement.dispatchEvent(new x.constructor(x.type,x));
    }
    blur(x){
        this.firstlevelElement.dispatchEvent(new x.constructor(x.type,x));
    }
    
    typeConverter(t){
        let [password,numeric] = t;
        if(password){
            return 'password';
        }else if(numeric){
            return 'number';
        }else{
            return 'text'
        }
    }
    private defaultInputHandler;
    onRenderCompleted(){
        this.inputElement = <HTMLTextAreaElement>(this.firstlevelElement.querySelector('.V-1F7F8045-5092-41F8-972A-A633C72BE80F'));

        if(this.isEventsSet==false){
            this.defaultInputHandler = ()=>this.handleInputEvent();
            this.inputElement.addEventListener("input",this.defaultInputHandler);
            this.inputElement.addEventListener('focusout',_=>{
                this.caretposition = this.inputElement.selectionStart;
            });
        }
    }
    handleInputEvent(){
        if(this.maxlength && this.inputElement.value.length>this.maxlength)
            this.inputElement.value=this.inputElement.value.substring(0,this.maxlength);
        else
            this.text=this.inputElement.value;
    }
    
    copy(){
        let element =this.inputElement;
        element.select();
        element.setSelectionRange(0, 99999); 
        document.execCommand("copy");
        this.dataContext.showCopiedMessage()
    }
    
    private isEventsSet:boolean;
    SetupRegex(){
        return;
        if(this.isEventsSet==true)
            return;
        if(this.inputElement==null)
            return;
        if(this.placeholder==null)
            return;
        if(this.slots==null)
            return;
        let pattern = this.placeholder;
        let slots =new Set<string>(this.slots ?? '_');
        let prev = (j => Array.from(pattern, (c,i) => slots.has(c)? j=i+1: j))(0);
        let first = [...pattern].findIndex(c => slots.has(c));
        let accept = new RegExp(this.accepts || "\\d", "g");
        
        let clean = input => {
            input = input.match(accept) || [];
            return Array.from(pattern, c =>
                input[0] === c || slots.has(c) ? input.shift() || c : c
            );
        };
        let format = () => {
            const [i, j] = [this.inputElement.selectionStart, this.inputElement.selectionEnd].map(i => {
                i = clean(this.inputElement.value.slice(0, i)).findIndex(c => slots.has(c));
                return i<0? prev[prev.length-1]: back? prev[i-1] || first: i;
            });
            this.inputElement.value = clean(this.inputElement.value).join(``);
            this.inputElement.setSelectionRange(i, j);
            back = false;
        };
        let formatInput = () => {
            format();
            this.text=this.inputElement.value;
            back = false;
        };
        let back = false;
        this.inputElement.addEventListener("keydown", (e) => back = e.key === "Backspace");
        if(this.defaultInputHandler!=null)
            this.inputElement.removeEventListener("input",this.defaultInputHandler);
        this.inputElement.addEventListener("input", formatInput);
        this.inputElement.addEventListener("focus", format);
        this.inputElement.addEventListener("blur", () => this.inputElement.value === pattern && (this.inputElement.value=""));
    }
}
